const MENU_INJECTION_KEY = "rootMenu";
const SUB_MENU_INJECTION_KEY = "subMenu:";

export { MENU_INJECTION_KEY, SUB_MENU_INJECTION_KEY };
//# sourceMappingURL=tokens.mjs.map
